<template>
  <div class="mine_left">
    <router-link :to="{path:'/user',query:{m:'profile'}}" class="mine_leftItem flex"
      :class="this.seletedMenu == 'profile'?'active':''">
      <img v-if="this.seletedMenu != 'profile'" src="../../assets/g_icon_1.png" />
      <img v-if="this.seletedMenu == 'profile'" src="../../assets/g_icon_1_x.png" />
      <span>个人信息</span>
    </router-link>
    <router-link :to="{path:'/user',query:{m:'class'}}" class="mine_leftItem flex"
      :class="this.seletedMenu == 'class'?'active':''">
      <img v-if="this.seletedMenu != 'class'" src="../../assets/g_icon_2.png" />
      <img v-if="this.seletedMenu == 'class'" src="../../assets/g_icon_2_x.png" />
      <span>我的课程</span>
    </router-link>
    <router-link :to="{path:'/user',query:{m:'order'}}" class="mine_leftItem flex"
      :class="this.seletedMenu == 'order'?'active':''">
      <img v-if="this.seletedMenu != 'order'" src="../../assets/g_icon_3.png" />
      <img v-if="this.seletedMenu == 'order'" src="../../assets/g_icon_3_x.png" />
      <span>我的订单</span>
    </router-link>
    <router-link :to="{path:'/user',query:{m:'point'}}" class="mine_leftItem flex"
      :class="this.seletedMenu == 'point'?'active':''">
      <img v-if="this.seletedMenu != 'point'" src="../../assets/g_icon_4.png" />
      <img v-if="this.seletedMenu == 'point'" src="../../assets/g_icon_4_x.png" />
      <span>我的学分</span>
    </router-link>
    <router-link :to="{path:'/user',query:{m:'receipt'}}" class="mine_leftItem flex"
      :class="this.seletedMenu == 'receipt'?'active':''">
      <img v-if="this.seletedMenu != 'receipt'" src="../../assets/g_icon_5.png" />
      <img v-if="this.seletedMenu == 'receipt'" src="../../assets/g_icon_5_x.png" />
      <span>发票信息</span>
    </router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      seletedMenu: "",
    }
  },
  mounted() {
    this.seletedMenu = this.menu;
  },
  props: {
    menu: {
      type: String,
      required: true
    }
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.seletedMenu = this.$route.query.m;
      },
    },
  },
};
</script>

<style scoped>
.mine_left {
  margin-top: 16px;
  padding: 16px;
  background-color: #fff;
  margin-right: 16px;
  /* min-height: 684px; */
  box-sizing: border-box;
}

.mine_leftItem {
  margin-top: 24px;
  padding: 16px;
  min-width: 198px;
  box-sizing: border-box;
}

.mine_leftItem img {
  width: 26px;
  height: 26px;
  margin-right: 16px;
}

.mine_leftItem span {
  color: rgba(34, 34, 34, 1);
  font-size: 20px;
}

.mine_leftItem.active {
  background: #eff1f7;
  border-radius: 4px;
}

.mine_leftItem.active span {
  color: rgba(34, 34, 34, 1);
}
</style>